import { Transform, Type } from 'class-transformer';
import { IsBoolean, IsInt, IsOptional, IsString, Max, Min } from 'class-validator';

/** Query params of `GET /suppliers`: server-side search + pagination, mirrors
 * `GetIngredientsQueryDto`. `pageSize`'s cap of 200 also doubles as the
 * "give me effectively everything" request internal pickers (merge survivor
 * autocomplete, edit-by-id deep link) make — HACCP tenants stay well under it. */
export class GetSuppliersQueryDto {
  /** Case-insensitive substring match against `name` or `vatNumber`. */
  @IsOptional()
  @IsString()
  q?: string;

  @IsOptional()
  @Transform(({ value }) => value === 'true' || value === true)
  @IsBoolean()
  includeInactive?: boolean;

  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  page?: number;

  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(200)
  pageSize?: number;
}
